import { render, staticRenderFns } from "./RevisarReservaNavidadView.vue?vue&type=template&id=7827f339&"
import script from "./RevisarReservaNavidadView.vue?vue&type=script&lang=ts&"
export * from "./RevisarReservaNavidadView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports